"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
const FONT_STYLE = `
    .hero-grain::after {
        content: '';
        position: absolute;
        inset: 0;
        background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.05'/%3E%3C/svg%3E");
        pointer-events: none;
        z-index: 2;
    }
`;
const ContactHero = () => {
  const $ = _c(28);
  const containerRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      target: containerRef,
      offset: ["start start", "end start"]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    scrollYProgress
  } = useScroll(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [0, 1];
    t2 = ["0%", "30%"];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const y = useTransform(scrollYProgress, t1, t2);
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [0, 1];
    t4 = [1, 0];
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  const opacity = useTransform(scrollYProgress, t3, t4);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <style>{FONT_STYLE}</style>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== y) {
    t6 = {
      y
    };
    $[6] = y;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <img src="https://images.unsplash.com/photo-1518546305927-5a555bb7020d?q=80&w=1600&auto=format&fit=crop" alt="Vintage letters and correspondence, Global Girmitiya Council contact" className="w-full h-full object-cover grayscale-[40%] sepia-[20%] opacity-40" />;
    t8 = <div className="absolute inset-0 bg-gradient-to-t from-[#0F1C2E] via-[#0F1C2E]/60 to-transparent" />;
    $[8] = t7;
    $[9] = t8;
  } else {
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6) {
    t9 = <motion.div style={t6} className="absolute inset-0 z-0">{t7}{t8}</motion.div>;
    $[10] = t6;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== opacity) {
    t10 = {
      opacity
    };
    $[12] = opacity;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  let t12;
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      opacity: 0,
      y: 20
    };
    t12 = {
      opacity: 1,
      y: 0
    };
    t13 = {
      duration: 0.8,
      ease: "easeOut"
    };
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
  } else {
    t11 = $[14];
    t12 = $[15];
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <motion.div initial={t11} animate={t12} transition={t13} className="flex items-center justify-center gap-2 sm:gap-3 mb-4 sm:mb-6"><div className="w-8 h-px bg-[#DF6D2A]" /><span className="font-body text-[11px] tracking-[0.25em] uppercase text-[#DF6D2A]">Reach Out</span><div className="w-8 h-px bg-[#DF6D2A]" /></motion.div>;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  let t16;
  let t17;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      opacity: 0,
      y: 20
    };
    t16 = {
      opacity: 1,
      y: 0
    };
    t17 = {
      duration: 0.8,
      delay: 0.1,
      ease: "easeOut"
    };
    $[18] = t15;
    $[19] = t16;
    $[20] = t17;
  } else {
    t15 = $[18];
    t16 = $[19];
    t17 = $[20];
  }
  let t18;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <motion.h1 initial={t15} animate={t16} transition={t17} className="font-display text-[36px] sm:text-[48px] md:text-[72px] lg:text-[88px] font-light text-[#F4EFE6] leading-none mb-4 sm:mb-6 tracking-tight">Get in <em className="text-[#C9A84C] italic">Touch</em></motion.h1>;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.2,
      ease: "easeOut"
    }} className="font-body text-[14px] sm:text-[16px] md:text-[18px] font-light text-[#F4EFE6]/70 leading-[1.7] sm:leading-relaxed max-w-[600px] mx-auto">Whether you are a researcher, a descendant with a story to share, or looking to collaborate, we welcome your correspondence.</motion.p>;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[23] !== t10) {
    t20 = <motion.div style={t10} className="relative z-10 text-center px-4 sm:px-6 max-w-[800px] mt-8 sm:mt-12 md:mt-16">{t14}{t18}{t19}</motion.div>;
    $[23] = t10;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  let t21;
  if ($[25] !== t20 || $[26] !== t9) {
    t21 = <>{t5}<section ref={containerRef} className="relative min-h-[420px] h-[60svh] max-h-[700px] bg-[#0F1C2E] overflow-hidden flex items-center justify-center hero-grain">{t9}{t20}</section></>;
    $[25] = t20;
    $[26] = t9;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  return t21;
};
export default ContactHero;